import { AiOutlineLinkedin } from "react-icons/ai";
import { AiFillGithub } from "react-icons/ai";

const HeaderDataLink = [
  {
    id: 3,
    link: "https://www.linkedin.com/in/bello-adetayo-olamiji-436375221/",
    icon: <AiOutlineLinkedin />,
  },
  {
    id: 4,
    link: "https://github.com/bello682?tab=repositories",
    icon: <AiFillGithub />,
  },
];

export default HeaderDataLink;
